module.exports = __webpack_public_path__ + "static/media/not-found-middle.579ebc22.svg";